// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__klDFO","modalBody":"StaffClientsModal_modalBody__LyRPN","formControl":"StaffClientsModal_formControl__EtvV1"};